var IconButton        = require("app/ui/IconButton"),
    PrintRequestPopup = require("./PrintRequestPopup"),
    config            = require("app/config"),
    frameThrottle     = require("enyo-perf/utils").frameThrottle,
    get               = require("object-path").get,
    icons             = require("app/theme/icons"),
    kind              = require("enyo/kind"),
    logger            = require("enyo/logger");

require("app/theme/IconButton--neutral-ghost.less");

module.exports = kind(/** @lends  app.Fotocadeau.BuyButton.prototype */ {

    /**
     * @private
     */
    name: "app.Fotocadeau.BuyButton",

    /**
     * @private
     */
    kind: IconButton,

    /**
     * @private
     */
    classes: "app-fotocadeau-buy-button",

    /**
     * @private
     */
    theme: "neutral-ghost",

    /**
     * The mediaItem
     *
     * @type  {?Object}
     * @public
     */
    mediaItem: null,

    /**
     * @type  {string}
     */
    cartIcon: icons["app.Fotocadeau.BuyButton.buy"],

    /**
     * Status of the request for a print url:
     *  * -1 No `shopLink`, not awaiting a result
     *  * 0 No `shopLink`, pending request
     *  * 1 `shopLink` ready
     *
     * @type {number}
     * @readonly
     * @public
     */
    requestStatus: -1,

    /**
     * The link to the shop page
     *
     * @type {string=}
     * @readonly
     * @public
     */
    shopLink: null,

    /**
     * @private
     */
    showCaption: true,

    /**
     * @private
     */
    handlers: {
        ontap:                "ontap",
        onCancelPrintRequest: "onCancelPrintRequest"
    },

    /**
     * @private
     */
    bindings: [{
        from: "requestStatus",
        to:   ".$.popup.requestStatus"
    }, {
        from: "shopLink",
        to:   ".$.popup.shopLink"
    }],

    /**
     * @private
     */
    observers: {
        update: ["mediaItem", "showCaption", "requestStatus"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.observe("app.$.authService.isLoggedIn", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService         = this.app.$.i18nService,
            authService         = this.app.$.authService,
            mediaItem           = this.get("mediaItem") || null,
            allowBuyButton      = get(config, "fotocadeau.buyButton", false),
            isFotocadeauEnabled = mediaItem && get(mediaItem, "photo_print_enabled", false),
            showCaption         = this.get("showCaption"),
            requestStatus       = this.get("requestStatus");

        // No mediaItem, item not for sale, or no logged in user
        if (!allowBuyButton || !mediaItem || !isFotocadeauEnabled || authService.isLoggedIn !== 1) {
            this.hide();

            return;
        }

        if (requestStatus === 0) {
            this.addClass("loading");
            this.set("icon", icons["app.Fotocadeau.BuyButton.loading"]);
            this.set("caption", showCaption ? i18nService.getString("app.Fotocadeau.BuyButton.loading") : null);
            this.setAttribute("title", i18nService.getString("app.Fotocadeau.BuyButton.loading"));
        }
        else {
            this.removeClass("loading");
            this.set("icon", this.get("cartIcon"));
            this.set("caption", showCaption ? i18nService.getString("app.Fotocadeau.BuyButton.caption") : null);
            this.setAttribute("title", i18nService.getString("app.Fotocadeau.BuyButton.tooltip"));
        }

        this.show();
    },

    /**
     * @private
     */
    onCancelPrintRequest: function() {
        this.cancelPrintRequest();
    },

    /**
     * @private
     */
    mediaItemChanged: function() {
        this.cancelPrintRequest();
    },

    /**
     * @private
     */
    cancelPrintRequest: function() {
        this.set("requestStatus", -1);
        this.set("shopLink", null);
        this.hidePopup();
    },

    /**
     * Since taps could be bubbled from a popup owned by this control, we want
     * to verify the tap event's origin before handling it.
     *
     * @param  {enyo.Control}  sender  The sender
     * @param  {Object}        event   The event
     * @private
     */
    ontap: function(sender, event) {
        var node      = this.hasNode(),
            mediaItem = this.get("mediaItem");

        // No media item supplied
        if (!mediaItem) {
            return;
        }

        if (node && node.contains(event.target)) {
            this.requestStatus !== 0 && this.requestPrint();
        }
    },

    /**
     * @private
     */
    requestPrint: function() {
        var mediaItem = this.get("mediaItem");

        // No media item supplied
        if (!mediaItem) {
            return;
        }

        // Set status
        this.set("shopLink", null);
        this.set("requestStatus", 0);

        // Create popup
        this.showPopup();

        // Request print
        this.app.$.fotocadeauService.requestPrint(mediaItem)
            .then(this.bindSafely(function(response) {
                if (mediaItem && response.media_id === mediaItem.id) {
                    switch (response.status) {
                        case "ok":
                            this.onSuccess(response.data);
                            break;
                        case "error":
                        default:
                            this.onFail();
                            break;
                    }
                }
            }))
            .catch(this.bindSafely(function(error) {
                logger.error(error);

                if (typeof Sentry !== "undefined" && error instanceof Error) {
                    Sentry.captureException(error);
                }

                this.onFail();
            }));
    },

    /**
     * @param  {Object}  printSession  The print session
     * @private
     */
    onSuccess: function(printSession) {
        this.set("shopLink", printSession.url);
        this.set("requestStatus", 1);
    },

    /**
     * @private
     */
    onFail: function() {
        this.set("shopLink", null);
        this.set("requestStatus", 1);
    },

    /**
     * @private
     */
    showPopup: function() {
        var message;

        if (!this.$.popup) {
            message             = this.createComponent({
                name: "popup",
                kind: PrintRequestPopup
            });
            message.render();
            message.requestShow(true, false);
            message.on("hidden", function() {
                message.destroy();
            });
        }
    },

    /**
     * @private
     */
    hidePopup: function() {
        var $popup = this.$.popup;

        $popup && $popup.requestHide(true, false);
    }

});
